import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { ProjectEntityListState } from './project-entity-list.state';
import type { ProjectListState } from '../project-list.state';

const selectProjectListState = createFeatureSelector('projectList');

export const selectProjectEntityListState = createSelector(
  selectProjectListState,
  (projectListState: ProjectListState) => projectListState.projectEntityListState
);

export const selectProjectEntityList = createSelector(
  selectProjectEntityListState,
  (state: ProjectEntityListState) => state.projectEntityList
);

export const selectCount = createSelector(selectProjectEntityListState, (state: ProjectEntityListState) => state.count);

export const selectCanAddProject = createSelector(selectProjectEntityListState, (state: ProjectEntityListState) => {
  const canAddProject = state.rootActions[0] && state.rootActions[0].AddableReferences.findIndex(item => item.ProductTypeId === 'Project');
  return canAddProject !== -1;
});

export const selectLoading = createSelector(
  selectProjectEntityListState,
  (state: ProjectEntityListState) => state.projectEntityListLoading
);

export const selectQueryParams = createSelector(selectProjectEntityListState, (state: ProjectEntityListState) => {
  return {
    searchPhrase: state.searchPhrase,
    onlyMine: state.onlyMine,
    page: state.page,
    pageSize: state.pageSize
  };
});

export const selectSearchPhrase = createSelector(selectProjectEntityListState, (state: ProjectEntityListState) => state.searchPhrase);

export const selectOnlyMine = createSelector(selectProjectEntityListState, (state: ProjectEntityListState) => state.onlyMine);

export const selectPage = createSelector(selectProjectEntityListState, (state: ProjectEntityListState) => state.page);

export const selectPageSize = createSelector(selectProjectEntityListState, (state: ProjectEntityListState) => state.pageSize);
